import React, { useRef, useState } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
// import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { getMonthlyDetails, getMonthlyDetailsReport } from "./reportsApi";

import DownloadIcon from "@mui/icons-material/Download";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import SalesSummary from "../../../common/salarySummery";
import {
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
} from "../../../utils/commonUtils";
import { getCounterSalesReport } from "./reportsApi";
import TableReport from "./table";
import axios from "axios";
import dayjs from "dayjs";
import { useNavigate } from "react-router";
import { ArrowBackIcon } from "../../../common/icon";
// import DateComponent from "./dateComponent";

export default function GstReportText({ data }) {
  const [open, setOpen] = useState(false);
  const datePickerRef2 = useRef();
 const navigate = useNavigate();

  //------------date
  const [date, setDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [dateFocused, setDateFocused] = useState(false);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);

  const [SelectedStartDate, setSelectedStartDate] = useState(
    dayjs().startOf("month")
  );
  // const [endDate, setEndDate] = useState(
  //   getLastDateOfCurrentMonthPayloadFormat()
  // );

  const [SelectedEndDate, setSelectedEndDate] = useState(dayjs());

  const [startDateFormat, setstartDateFormat] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"))

  const datePickerOnChange = (newValue) => {
    setSelectedStartDate(newValue);
    setDate(newValue.format("DD-MMMM-YYYY")); 
    setstartDateFormat(newValue.format("YYYY-MM-DD")); 
    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  const datePickerOnChangeEnd = (newValue) => {
    setSelectedEndDate(newValue);
    setDisplayEndDate(newValue.format("DD-MMMM-YYYY")); 
    setEndDate(newValue.format("YYYY-MM-DD")); 
    setEndDateOpen(false);
  };

  function addLeadingZero(value) {
    return value < 10 ? "0" + value : value;
  }

  const displayDateFormat = () => {
    var currentDate = new Date();
    let dateContainer = String(currentDate).split(" ");

    var year = dateContainer[2];
    var month = dateContainer[1];

    var day = dateContainer[3];

    var formattedDate =
      year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);

    return formattedDate;
  };
  const [gstReports, setgstReports] = useState({
    totalSales: "",
    totalGST: 0,
    gstReports: [],
  });
  const [billFilter, setBillFilter] = useState("cash");

  const getYear = (date) => {
    let ar = date.split("-");
    return ar[ar.length - 1];
  };
  // const [date, setDate] = useState(getYear(displayDateFormat()));

  const [startDate, setStartDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const getData = async (param) => {
    await getMonthlyDetails(param).then((res) => {
      console.log("Gst Report ", res?.data?.data);
      setgstReports({
        ...gstReports,
        totalGST: res?.data?.data?.totalGST || 0,
        gstReports: res?.data?.data?.dateWiseGST,
      });
    });
  };


  useEffect(() => {
    console.log("datE ", date);
    getData({
      // year: Number(payloadDateFormat().split("-")[0]),
      fromDate: startDateFormat,
      toDate: endDate,
    });
  }, [startDateFormat, endDate]);
  useEffect(() => {
    console.log("datE ", date);
    getData({
      // year: Number(payloadDateFormat().split("-")[0]),
      fromDate: startDateFormat,
      toDate: endDate,
    });
  }, []);

  const downloadXLSXFile = async (param) => {
    try {
      const response = await getMonthlyDetailsReport(param, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "GST Report.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };
  //   const [SelectedEndDate, setSelectedEndDate] = useState(null);
  return (
    <Box
      sx={{
        py: "17px",
        px: { sm: "30px", xs: "20px" },
        background: "#ede9ff",
        minHeight: "100vh",
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid container alignItems="center" spacing={2}>
          {/* Back Icon */}
          <Grid item>
            <ArrowBackIcon
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/home")}
            />
          </Grid>

          {/* Title Section */}
          <Grid item xs>
            <Box
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px",
                mt: "10px",
                borderRadius: "5px",
                color: "#01008B", // optional text color
                textAlign: "left",
                marginBottom: "10px",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "20px",
                fontWeight: 500,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "18px" },
                }}
              >
                GST Report
              </Typography>
            </Box>
          </Grid>
        </Grid>
        {/* Date Input */}
        <Grid
          container
          spacing={{ xs: 0, sm: 1 }}
          sx={{ pl: 2 }}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} sm={9} md={10}>
            <TextField
              label="Date"
              size="small"
              value={
                SelectedStartDate && SelectedEndDate
                  ? `${SelectedStartDate.format(
                      "DD-MM-YYYY",
                    )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                  : SelectedStartDate
                    ? `${SelectedStartDate.format("DD-MM-YYYY")}`
                    : ""
              }
              id="datepickerfield"
              placeholder="Select date range"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <CalendarMonthIcon
                    sx={{
                      cursor: "pointer",
                      fontSize: { xs: "14px", sm: "14px", md: "18px" },
                      mr: 1,
                    }}
                    onClick={() => setStartDateOpen(true)} // trigger open
                  />
                ),
                sx: {
                  background: "#fff",
                  borderRadius: 1,
                  cursor: "pointer",
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  fontWeight: 500,
                },
              }}
              onClick={() => setStartDateOpen(true)} // trigger open
              sx={{
                width: "100%",
                height: "50px",
                border: "none",
                "& fieldset": { border: "none" },
              }}
            />

            <Box sx={{ position: "relative" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={startDateOpen}
                  onOpen={() => setStartDateOpen(true)}
                  onClose={() => setStartDateOpen(false)}
                  value={SelectedStartDate}
                  onChange={(val) => {
                    datePickerOnChange(val);
                  }}
                  maxDate={SelectedEndDate || undefined}
                  slotProps={{
                    popper: {
                      placement: "bottom-end",
                      anchorEl: document.querySelector("#datepickerfield"),
                      sx: { zIndex: 1500 },
                    },
                    textField: { style: { display: "none" } },
                  }}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={endDateOpen}
                  onOpen={() => setEndDateOpen(true)}
                  onClose={() => setEndDateOpen(false)}
                  value={SelectedEndDate}
                  onChange={(val) => {
                    datePickerOnChangeEnd(val);
                  }}
                  minDate={SelectedStartDate || undefined}
                  slotProps={{
                    popper: {
                      placement: "bottom-start",
                      anchorEl: document.querySelector("#datepickerfield"),
                      sx: { zIndex: 1500 },
                    },
                    textField: { style: { display: "none" } },
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Grid>

          <Grid
            item
            md={2}
            sm={3}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              fullWidth
              sx={{
                height: { sm: "35px", xs: "38px", md: "41px" },
                backgroundColor: "#14008B",
                mb: 1,
                fontSize: { xs: "12px", sm: "12px", md: "15px" },
              }}
              endIcon={<FileDownloadIcon />}
              onClick={() =>
                downloadXLSXFile({
                  fromDate: startDateFormat,
                  toDate: endDate,
                })
              }
            >
              Download
            </Button>
          </Grid>
        </Grid>

        <Grid container alignItems="center">
          <Grid
            item
            xs={"auto"}
            sx={{
              padding: "8px 16px",
              margin: "8px 8px 0px 0",
              fontWeight: "500",
              backgroundColor: "#CCCCFF",
              borderRadius: "8px",
              marginLeft: "15px",
            }}
          >
            <Typography
              component="p"
              sx={{
                display: "flex",
                alignItems: "center",
                marginLeft: "5px",
                color: "#00008B",
              }}
            >
              <Typography
                component="span"
                sx={{
                  fontWeight: 500,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Total Amount:&nbsp;&nbsp;&nbsp;
              </Typography>
              <Typography
                component="span"
                sx={{
                  fontWeight: "bold",
                  marginLeft: "8px",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                {Number(gstReports?.totalGST || 0).toFixed(2)}
              </Typography>
            </Typography>
          </Grid>
        </Grid>

        {/* Total Sale */}
      </Grid>
      {/* Table */}
      <Box mt={4} sx={{ borderRadius: 2, background: "#fff" }}>
        <TableReport
          salesData={[]}
          colName={[
            {
              title: "Category",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Items",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Amount",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Category",
              attribute: {
                xs: 3,
              },
            },
          ]}
          data={gstReports?.gstReports ?? []}
        />
      </Box>
    </Box>
  );
}
